/** Parse a single CSV line into trimmed, non-empty header cells (quote-aware). */
export function parseCsvLine(line: string): string[] {
  const headers: string[] = [];
  let current = "";
  let inQuotes = false;

  for (const ch of line) {
    if (ch === '"') {
      inQuotes = !inQuotes;
    } else if (ch === "," && !inQuotes) {
      headers.push(current.trim());
      current = "";
    } else {
      current += ch;
    }
  }
  if (current !== "" || headers.length > 0) headers.push(current.trim());

  return headers.filter((h) => h !== "");
}

/**
 * Read just the header row from a CSV file in the browser. Uses FileReader for
 * broad support, and strips a leading BOM so the headers match what the server
 * parses (it strips the BOM too).
 */
export function readCsvHeaders(file: File): Promise<string[]> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      const text = typeof reader.result === "string" ? reader.result : "";
      const firstLine = text.replace(/^\uFEFF/, "").split(/\r?\n/)[0] ?? "";
      resolve(parseCsvLine(firstLine));
    };
    reader.onerror = () => resolve([]);
    // Only the header row is needed, so read a small slice rather than the whole
    // file (which can be up to 5 MB).
    reader.readAsText(file.slice(0, 64 * 1024));
  });
}
